export default __webpack_public_path__ + "static/media/immobilier.eddfa59f.png";